import { comparisonData } from "@/mocks/categories";

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <i
          key={star}
          className={`text-sm ${
            star <= Math.floor(rating)
              ? "ri-star-fill text-accent-500"
              : star - rating < 1 && star - rating > 0
              ? "ri-star-half-line text-accent-500"
              : "ri-star-line text-foreground-300"
          }`}
        ></i>
      ))}
    </div>
  );
}

function ProgressBar({ value, label }: { value: number; label: string }) {
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <span className="text-[11px] text-foreground-500 font-label">{label}</span>
        <span className="text-[11px] text-foreground-700 font-semibold">{value}/10</span>
      </div>
      <div className="w-full h-1.5 rounded-full bg-background-200 overflow-hidden">
        <div
          className="h-full rounded-full bg-accent-500 transition-all duration-500"
          style={{ width: `${value * 10}%` }}
        ></div>
      </div>
    </div>
  );
}

export default function ComparisonSection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em] mb-3 font-label">
            Compare &amp; Decide
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 font-heading">
            Compare Top OOPBuy Spreadsheets
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comparisonData.map((item, index) => (
            <div
              key={index}
              className="rounded-[24px] bg-background-100 p-6 flex flex-col hover:bg-background-200/70 transition-colors duration-200"
            >
              {/* Tag */}
              {item.tag && (
                <span className="self-start px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-[10px] font-semibold uppercase tracking-wider mb-4">
                  {item.tag}
                </span>
              )}

              {/* Visual - star rating + progress bars */}
              <div className="flex-1 space-y-4">
                <div className="flex items-center justify-between">
                  <StarRating rating={item.rating} />
                  <span className="text-sm font-semibold text-foreground-800">{item.rating}</span>
                </div>
                <ProgressBar value={item.accuracy} label="Accuracy" />
                <ProgressBar value={item.speed} label="Speed" />
                <ProgressBar value={item.easeOfUse} label="Ease of Use" />
              </div>

              {/* Name & details */}
              <div className="mt-5 pt-4 border-t border-background-300/60">
                <h3 className="text-lg font-bold text-foreground-950 font-heading text-center">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-500 text-center mt-1.5">
                  Best for: {item.bestFor}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-700 hover:text-foreground-950 transition-colors"
          >
            View all spreadsheets on main platform
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}